module.exports = __webpack_public_path__ + "img/mobile/Menus-betmenu/btn-autoplay-up@3x.png?0.0.53";